import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { CrossCard } from '../ui/CrossCard'
import { ThemeToggle } from '../ui/ThemeToggle'

export { ErrorText } from '../ui/primitives'

export function Logo({ to = '/' }: { to?: string }) {
  return (
    <Link to={to} className="group inline-flex items-center gap-2.5 text-ink">
      <img src="/favicon.svg" alt="" className="h-8 w-8 transition-transform group-hover:-rotate-6" />
      <span className="font-display text-2xl font-bold tracking-tight">Vexa</span>
    </Link>
  )
}

/** Centered single-card layout for pre-join, waiting and status screens. */
export function CenteredCard({
  children,
  wide = false,
  index,
}: {
  children: ReactNode
  wide?: boolean
  index?: string
}) {
  return (
    <div className="grid-paper flex min-h-full flex-col">
      <header className="flex items-center justify-between px-5 py-4 sm:px-8">
        <Logo />
        <ThemeToggle />
      </header>
      <main className="flex flex-1 items-center justify-center px-4 pt-4 pb-16">
        <CrossCard index={index} className={`rise-in w-full ${wide ? 'max-w-4xl' : 'max-w-md'} p-7 sm:p-9`}>
          {children}
        </CrossCard>
      </main>
    </div>
  )
}
